<div class="button-bar">
    @if(enableUITwo) {
        <clx-button i18n-title="@@operating.tasks.button.refresh" type="default" title="refresh" test-id="tasks.refresh.button"
            class="secondary-button" uiTwoIcon="simpl-icon-refresh" (click)="refresh()">Refresh</clx-button>
        } @else {
        <button class="default small icon fa fa-refresh" test-id="tasks.refresh.button" title="refresh"
            i18n-title="@@operating.tasks.button.refresh" (click)="refresh()"></button>
        }
</div>
<clx-accordion>
    <clx-accordion-item
        i18n-topic="@@task.list.active-tasks.accordeon.topic"
        test-id="task.list.active-tasks.accordeon"
        topic="Active tasks"
        state="opened"
    >
    <clx-data-grid
        [data]="activeTasksSource"
        [showFilter]="false"
        [showSearchPanel]="false"
        [showGroupPanel]="false"
        [showColumnChooser]="false"
        [selection]="{ mode : 'none' }"
        [remoteOperations]="remoteOperations"
        [showHeaderFilter]="false"
        [version]="1"
        id="active-tasks"
        test-id="task.list.active-tasks.grid"
    >

        <clx-grid-column
            dataField="StartDate"
            dataType="string"
            i18n-caption="@@task.list.active-tasks.start.caption"
            caption="Start"
            sortOrder="desc"
            sortIndex="1"
            test-id="task.list.active-tasks.grid.column.start-date"
        >
            <ng-template let-data="item">
                <span
                    title="{{data.value | datetimeUtcToLocal | datetime: 'L LTS'}}"
                >{{data.value | datetimeUtcToLocal | datetime: 'L LTS'}}</span>
            </ng-template>
        </clx-grid-column>

        <clx-grid-column
            dataField="Status"
            dataType="string"
            i18n-caption="@@task.list.active-tasks.progress.caption"
            caption="Progress"
            [allowSorting]="false"
            [showTitle]="true"
            test-id="task.list.active-tasks.grid.column.progress"
        >
        </clx-grid-column>

        <clx-grid-column
            dataField="Comment"
            dataType="string"
            i18n-caption="@@task.list.active-tasks.comment.caption"
            caption="Comment"
            [allowSorting]="false"
            [showTitle]="true"
            test-id="task.list.active-tasks.grid.column.comment"
        >
        </clx-grid-column>

        <clx-grid-column
            dataField="EndDate"
            dataType="datetime"
            caption=""
            [allowSorting]="false"
            alignment="right"
            [showTitle]="true"
            test-id="task.list.active-tasks.grid.column.cancel"
        >
            <ng-template let-data="item">
                <button
                    *ngIf="data.data.CanCancel"
                    class="fa fa-times icon default small"
                    title="cancel task"
                    i18n-title="@@task.list.active-tasks.cancel.button"
                    attr.test-id="task.list.active-tasks.cancel.button"
                    (click)="cancelTask(data.data.TaskId)"
                ></button>
            </ng-template>
        </clx-grid-column>
    </clx-data-grid>
    </clx-accordion-item>
    <clx-accordion-item
        i18n-topic="@@task.list.task-history.accordeon.topic"
        test-id="task.list.task-history.accordeon"
        topic="Task history"
    >
        <clx-data-grid
            [data]="taskHistorySource"
            [showFilter]="false"
            [showSearchPanel]="false"
            [showGroupPanel]="false"
            [showColumnChooser]="false"
            [selection]="{ mode : 'none' }"
            [remoteOperations]="remoteOperations"
            [showHeaderFilter]="false"
            [version]="1"
            id="tasks-history"
            test-id="task.list.task-history.grid"
        >

            <clx-grid-column
                dataField="StartDate"
                dataType="string"
                i18n-caption="@@task.list.task-history.start.caption"
                caption="Start"
                sortOrder="desc"
                sortIndex="1"
                test-id="task.list.task-history.grid.column.start-date"
            >
                <ng-template let-data="item">
                    <span attr.title="{{data.value | datetimeUtcToLocal | datetime: 'L LTS'}}">{{data.value | datetimeUtcToLocal | datetime: 'L LTS'}}</span>
                </ng-template>
            </clx-grid-column>

            <clx-grid-column
                dataField="Status"
                dataType="string"
                i18n-caption="@@task.list.task-history.progess.caption"
                caption="Progress"
                [allowSorting]="false"
                [showTitle]="true"
                test-id="task.list.task-history.grid.column.progress"
            ></clx-grid-column>

            <clx-grid-column
                dataField="Comment"
                dataType="string"
                i18n-caption="@@task.list.task-history.comment.caption"
                caption="Comment"
                [allowSorting]="false"
                [showTitle]="true"
                test-id="task.list.task-history.grid.column.comment"
            ></clx-grid-column>

            <clx-grid-column
                dataField="FinishStatus"
                dataType="number"
                i18n-caption="@@task.list.task-history.status.caption"
                caption="Status"
                [allowSorting]="false"
                alignment="center"
                test-id="task.list.task-history.grid.column.status"
            >
                <ng-template let-data="item">
               
                    <span
                        class="fa fa-check big"
                        *ngIf="data.data.Succeeded"
                        title="Succeeded"
                        i18n-title="@@task.list.task-history.icon.title.succeeded"
                        attr.test-id="task.list.task-history.icon.succeeded"
                    ></span>
                    <span
                        class="fa fa-times-circle big"
                        *ngIf="data.data.Cancelled"
                        title="Cancelled"
                        i18n-title="@@task.list.task-history.icon.title.cancelled"
                        attr.test-id="task.list.task-history.icon.cancelled"
                    ></span>
                    <span
                        class="fa fa-history big"
                        *ngIf="data.data.TimedOut"
                        title="Timeout"
                        i18n-title="@@task.list.task-history.icon.title.timeout"
                        attr.test-id="task.list.task-history.icon.timeout"
                    ></span>
                    <span
                        class="fa fa-exclamation-triangle big"
                        *ngIf="!data.data.Cancelled && !data.data.Succeeded && !data.data.TimedOut"
                        title="Failed"
                        i18n-title="@@task.list.task-history.icon.title.failed"
                        attr.test-id="task.list.task-history.icon.failed"
                    ></span>
                </ng-template>
            </clx-grid-column>

            <clx-grid-column
                dataField="EndDate"
                dataType="datetime"
                i18n-caption="@@task.list.task-history.enddate.caption"
                caption="End"
                [allowSorting]="false"
                test-id="task.list.task-history.grid.column.end-date"
            >
                <ng-template let-data="item">
                    <span title="{{data.value | datetimeUtcToLocal | datetime: 'L LTS'}}">{{data.value | datetimeUtcToLocal | datetime: 'L LTS'}}</span>
                </ng-template>
            </clx-grid-column>

        </clx-data-grid>
    </clx-accordion-item>
</clx-accordion>